import { render } from "./WalletExchangeBreakdownSummary.vue?vue&type=template&id=4c1d5859&scoped=true"
import script from "./WalletExchangeBreakdownSummary.vue?vue&type=script&lang=js"
export * from "./WalletExchangeBreakdownSummary.vue?vue&type=script&lang=js"

import "./WalletExchangeBreakdownSummary.vue?vue&type=style&index=0&id=4c1d5859&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1d5859"]])

export default __exports__